import { render, staticRenderFns } from "./ResourceList.vue?vue&type=template&id=1a5b132b&scoped=true"
import script from "./ResourceList.vue?vue&type=script&lang=js"
export * from "./ResourceList.vue?vue&type=script&lang=js"
import style0 from "./ResourceList.vue?vue&type=style&index=0&id=1a5b132b&prod&lang=scss&scoped=true"
import style1 from "./ResourceList.vue?vue&type=style&index=1&id=1a5b132b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5b132b",
  null
  
)

export default component.exports